import { useState, type FormEvent } from "react";

const FORM_ID = "dahhesjoh653ivfvnvjg";
const FORM_ACTION = "https://readdy.ai/api/form/dahhesjoh653ivfvnvjg";

type Status = "idle" | "submitting" | "success" | "error";

export default function SubscribeForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const trapValue = String(formData.get("company_alt") ?? "").trim();
    if (trapValue) {
      setStatus("success");
      setFormError("");
      form.reset();
      return;
    }

    formData.delete("company_alt");
    setStatus("submitting");
    setFormError("");

    try {
      const response = await fetch(FORM_ACTION, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam = String(serverMsg).toLowerCase().includes("spam");
      const ok = response.ok && parsed?.code === "OK" && !isSpam;

      if (ok) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setFormError(serverMsg || "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，请检查连接后重试。");
    }
  };

  return (
    <form
      id="subscribe-form"
      data-readdy-form
      onSubmit={handleSubmit}
      className="w-full max-w-xl"
    >
      <div className="flex flex-col sm:flex-row gap-3">
        <label htmlFor="subscribe-email" className="sr-only">邮箱地址</label>
        <input
          id="subscribe-email"
          type="email"
          name="email"
          required
          placeholder="输入邮箱，每周收一次精选汇总"
          className="flex-1 px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
        />
        <input
          type="text"
          name="company_alt"
          className="contact-extra-field"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
        />
        <button
          type="submit"
          disabled={status === "submitting"}
          className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
        >
          {status === "submitting" ? "提交中..." : "订阅推送"}
        </button>
      </div>
      {status === "success" && (
        <p className="mt-3 text-sm text-secondary-800 flex items-center gap-1.5">
          <i className="ri-checkbox-circle-line" aria-hidden="true"></i>
          订阅成功，下期精选会准时送到你的邮箱。
        </p>
      )}
      {status === "error" && (
        <p className="mt-3 text-sm text-accent-700 flex items-center gap-1.5">
          <i className="ri-error-warning-line" aria-hidden="true"></i>
          {formError}
        </p>
      )}
    </form>
  );
}